<template>
  <div class="rechargeList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getList('status')"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="getList('status')">搜索</el-button>
    </div>

    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
      height="590"
    >
      <el-table-column prop="name" label="名称" align="center" min-width="240" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.name || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="240" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.type || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="point" label="获取积分" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.point || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import { sortEscape, changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      tableData: [],
      time: "",
      loading: false,
      total: 0,
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        uid: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 请求订单列表
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.queryPointList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.sortValue = sortEscape(column.order);
        this.params.sortKey = column.prop;
      } else {
        this.params.sortValue = "";
        this.params.sortKey = "";
      }
      this.getList();
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getList("status");
    },
  },
};
</script>
<style lang="scss">
.rechargeList-box {
  .icon {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .channel-switch {
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    .channel-item {
      flex: 1;
    }
    .daichong {
      flex: 2;
    }
  }
}
</style>

